import type { AppStage } from '@/api/types';
import type { FilterOption } from '@/components/ui/FilterSelect';

export type StageFilterValue = AppStage;

export const STAGE_FILTER_OPTIONS: FilterOption[] = [
  ...[1, 2, 3, 4, 5].map((n) => ({ value: `STAGE_${n}`, label: `Stage ${n}` })),
  { value: 'UA_OPS', label: 'UA Ops' },
];

// 기본 필터 — Stage 1(초기 게임)만 제외. 프로젝트 목록과 멤버별 권한 게임 목록이 같은 기본값을 쓴다.
export const DEFAULT_STAGE_FILTER: StageFilterValue[] = ['STAGE_2', 'STAGE_3', 'STAGE_4', 'STAGE_5', 'UA_OPS'];
